import React from 'react';

const WarningModal = ({ onAccept }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center">
      <div className="bg-white p-8 max-w-2xl mx-4">
        <h2 className="text-2xl font-bold mb-4 text-black">Important Notice</h2>
        <p className="text-gray-800 text-lg mb-8">
          By proceeding, you acknowledge that completing this application will affect your credit score. Please do not close this window during the process.
        </p>
        <div className="flex justify-center">
          <button
            onClick={onAccept}
            className="bg-suzGreen text-black px-8 py-3 hover:bg-opacity-90 transition-all duration-150"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default WarningModal; 